/**
 * StatusSyle consist of:
 *  - processStatusSyles I
 *  - ssueStatusStyle
 * Note: overriding-styles-with-classes https://material-ui.com/customization/components/#overriding-styles-with-classes
 */

export const processStatusStyles = (theme) => ({
//   button: {
//     padding: '2px 2px',
//   },
//   buttonOption: {
//     width: '120px',
//   },
//   buttonSelect: {
//     minWidth: '30px',
//   },
//   red: {
//     color: '#fff',
//     background: 'red',
//   },
//   blue: {
//     color: '#fff',
//     background: 'blue',
//   },
  successStyle: {
    color: '#fff',
    background: '#008000',
  },
  receivedStyle: {
    color: '#fff',
    background: '#4682b4',
  },
  processingStyle: {
    color: '#fff',
    background: '#4682b4',
  },
  forwardStyle: {
    color: '#333',
    background: '#b0c4de',
  },
  pendingStyle: {
    color: '#333',
    background: '#b0c4de',
  },
});
